import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var firebaseConfig = {
  apiKey: "AIzaSyAysaY3_krHJORmgJGp6VOhefHFibCn4l8",
  authDomain: "carpe-diem-calendar-9db19.firebaseapp.com",
  projectId: "carpe-diem-calendar-9db19",
  storageBucket: "carpe-diem-calendar-9db19.firebasestorage.app",
  messagingSenderId: "596141128261",
  appId: "1:596141128261:web:1cf84363fa10dffd83012c"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;